import { EntityBuilder } from '@decahedron/entity';
import ApiService from '@/services/api';
import User from '@/entities/User';

let instance: UserService = null;

export default class UserService {
    apiService: ApiService = null;

    usersList: User[] = null;

    constructor() {
        if (!instance) {
            this.apiService = new ApiService();
            instance = this;
        }

        return instance;
    }

    get list() {
        if (!this.usersList) {
            this.getList().then((users) => {
                this.usersList = users;
            });
        }

        return this.usersList || [];
    }

    getList() {
        return this.apiService.get('users')
            .then((response) => EntityBuilder.buildMany<User>(User, response.data));
    }

    get(userId: string) {
        return this.apiService.get(`users/${userId}`)
            .then((response) => EntityBuilder.buildOne(User, response.data));
    }

    current() {
        return this.apiService.get('users/current')
            .then((response) => EntityBuilder.buildOne(User, response.data));
    }

    deletePassport(userId: string) {
        return this.apiService.delete(`users/${userId}/passport`)
            .then((response) => EntityBuilder.buildOne(User, response.data));
    }

    block(userId: string) {
        return this.apiService.post(`users/${userId}/block`, {});
    }

    create(firstname: string, lastname: string, company: string, vat: string, email: string, password: string, passwordConfirmation: string) {
        const formData = new FormData();
        formData.append('firstname', firstname);
        formData.append('lastname', lastname);
        formData.append('company', company);
        formData.append('vat', vat);
        formData.append('email', email);
        formData.append('password', password);
        formData.append('password_confirmation', passwordConfirmation);
        formData.append('language', 'en');
        return this.apiService.post('users', formData)
            .then((response) => EntityBuilder.buildOne(User, response.data));
    }

    update(user: User) {
        return this.apiService.put(`users/${user.id}`, user.toJson())
            .then((response) => EntityBuilder.buildOne(User, response.data));
    }

    requestPasswordReset(email: string) {
        return this.apiService.post('password-reset/request', { email });
    }

    checkResetPasswordToken(token: string) {
        return this.apiService.get(`password-reset/${token}`);
    }

    resetPassword(token: string, password: string, passwordConfirmation: string) {
        const formData = new FormData();
        formData.append('token', token);
        formData.append('password', password);
        formData.append('password_confirmation', passwordConfirmation);
        return this.apiService.post('password-reset', formData);
    }
}
